import { render, staticRenderFns } from "./TokenMenu.vue?vue&type=template&id=83351be8"
import script from "./TokenMenu.vue?vue&type=script&lang=js"
export * from "./TokenMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports